import { getContentUsers, getPublicWorkouts } from '@/api/requests';
import router from '../../router';

const state = {
  users: [],
  exercises: [],
  workouts: [],

  createUser: false,
  selectedUserId: "",
  selectedUser: {},
  
  activity: true,
  workoutName: "",
  workoutDescription: "",
  workoutTime: "",
  workoutDate: new Date().toDateString(),
  workoutChoice: "",
  workoutDifficulty: 5,
  preivewImage1: "",
  filesToUpload: [],
};

const mutations = {
  updateAttribute(state, payload) {
    state[payload.type] = payload.value;
  },

  addUser(state, user) {
    state.users.push(user);
  },

  setFilesToUpload(state, files) {
    state.filesToUpload = files;
  },

  saveUsers(state, users) {
    state.users = users;
  },

  saveWorkouts(state, workouts) {
    state.workouts = workouts;
  },

  resetActivity(state) {
    state.workouts = [];
    state.selectedUserId = "";
    state.selectedUser = { };
    state.activity = true;
    state.workoutName = "";
    state.workoutDescription = "";
    state.workoutTime = "";
    state.workoutDate = new Date().toDateString();
    state.workoutChoice = "";
    state.workoutDifficulty = 5;
    state.preivewImage1 = "";
    state.filesToUpload = [];
  },

  updateUserLocation(state) {
    let index = state.users.indexOf(state.selectedUser);
    state.users.push(state.users.splice(index, 1)[0]);
  }
};

const actions = {
  loadUsers(context) {
    getContentUsers().then((response) => {
      context.commit('saveUsers', response.data.users);
    });
  },

  loadPublicWorkouts(context, userId) {
    getPublicWorkouts(userId).then((response) => {
      context.commit('saveWorkouts', response.data.data);
    });
  }
};

const getters = {

};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};